import React from 'react';
import useToggle, { CardAction } from '../../Hooks/useToggle';
import Drawer from '../../Components/Drawer';
import HeaderInverted from '../../Components/HeaderInverted';
import HeroWithBreadcrumb from '../../Components/HeroWithBreadcrumb';
import Footer from '../../Components/Footer';
import BackToTop from '../../Components/BackToTop';
import WorkPart from '../../Components/WorkPart';
import DemoCredentials from '../../Components/DemoCredentials';

const Demo: React.FC = () => {
    const [drawer, drawerAction] = useToggle(false);
    
    const toggleDrawer = drawerAction as CardAction;

    return (
        <>
            <Drawer drawer={drawer} action={toggleDrawer.toggle} />
            <HeaderInverted action={toggleDrawer.toggle}/>
            <HeroWithBreadcrumb
                title="Self Guided Demo"
                breadcrumb={[
                    { link: '/', title: 'Home' },
                    { link: '/demo', title: 'Demo' },
                ]}
            />
            <WorkPart />
            <DemoCredentials />
            <Footer className={''} />
            <BackToTop className="back-to-top-3" />
        </>
    );
}

export default Demo;